// Types
import type { TPatch } from '~/misc/patch/types';

export class PatchLabelResolver {
  static getListLabel(patches: TPatch[]): string {
    return (
      patches.map((patch: TPatch): string => patch.name as string).join(', ') || 'No areas set'
    );
  }
}
